export const FULLSCREEN_META_CFG = {
  WEBKIT: {
    requestFullscreen: 'webkitRequestFullscreen',
    exitFullscreen: 'webkitExitFullscreen',
    fullscreenElement: 'webkitFullscreenElement',
    fullscreenEnabled: 'webkitFullscreenEnabled',
    fullscreenchange: 'webkitfullscreenchange',
    fullscreenerror: 'webkitfullscreenerror',
  },
  MOZ: {
    requestFullscreen: 'mozRequestFullScreen',
    exitFullscreen: 'mozCancelFullScreen',
    fullscreenElement: 'mozFullScreenElement',
    fullscreenEnabled: 'mozFullScreenEnabled',
    fullscreenchange: 'mozfullscreenchange',
    fullscreenerror: 'mozfullscreenerror',
  },
  MS: {
    requestFullscreen: 'msRequestFullscreen',
    exitFullscreen: 'msExitFullscreen',
    fullscreenElement: 'msFullscreenElement',
    fullscreenEnabled: 'msFullscreenEnabled',
    fullscreenchange: 'MSFullscreenChange',
    fullscreenerror: 'MSFullscreenError',
  },
  DEFAULT: {
    requestFullscreen: 'requestFullscreen',
    exitFullscreen: 'exitFullscreen',
    fullscreenElement: 'fullscreenElement',
    fullscreenEnabled: 'fullscreenEnabled',
    fullscreenchange: 'fullscreenchange',
    fullscreenerror: 'fullscreenerror',
  },
};
